import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/icc-logo.png';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import NavContainer from './header/NavContainer';
import urls from '../../config/urls';


function Header(props) {
  return (
    <AppBar position="fixed" className="AppHeader">
      <Toolbar className="AppHeader-toolbar">
        <Link to={urls.root} className="AppHeader-logo">
          <img src={logo} alt="Institute of Catholic Culture Logo" />
        </Link>
        <NavContainer />
      </Toolbar>
    </AppBar>
  );
}

export default Header;